function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4292a694-4a8f-4fd7-8892-0f3807a44835",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.27 41.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-a216b48e-8df3-4a28-b256-57522ea9a010",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.63,0h0C9.24,0,0,9.24,0,20.64s9.24,20.64,20.63,20.64h0c11.4,0,20.64-9.24,20.64-20.64S32.03,0,20.63,0ZM34.21,30.45c-.37.94-.86,1.74-1.65,2.54-.8.8-1.59,1.29-2.54,1.65-.91.35-1.95.6-3.48.67-1.53.07-2.02.09-5.91.09s-4.38-.02-5.91-.09c-1.53-.07-2.57-.31-3.48-.67-.94-.37-1.74-.86-2.54-1.65-.8-.8-1.29-1.6-1.65-2.54-.35-.91-.6-1.95-.67-3.48-.07-1.53-.09-2.02-.09-5.91s.02-4.38.09-5.91c.07-1.52.31-2.57.67-3.48.37-.94.86-1.74,1.65-2.54.8-.8,1.6-1.29,2.54-1.65.91-.35,1.95-.6,3.48-.67,1.53-.07,2.02-.09,5.91-.09h0,0,0c3.89,0,4.38.02,5.91.09,1.53.07,2.57.31,3.48.67.94.37,1.74.86,2.54,1.65.8.8,1.29,1.6,1.65,2.54.35.91.59,1.95.67,3.48.07,1.53.09,2.02.09,5.91s-.02,4.38-.09,5.91c-.07,1.52-.31,2.57-.67,3.48Z",
    style: {
      fill: "#ff9be7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.81,12.61c-.26-.67-.57-1.15-1.07-1.65-.5-.5-.98-.81-1.65-1.07-.51-.2-1.26-.43-2.66-.49-1.51-.07-1.96-.08-5.79-.08-.48,0-.9,0-1.29,0h0c-2.67,0-3.18.02-4.5.08-1.4.06-2.16.3-2.66.49-.67.26-1.15.57-1.65,1.07-.5.5-.81.98-1.07,1.65-.2.51-.43,1.26-.49,2.66-.07,1.51-.08,1.96-.08,5.79s.01,4.28.08,5.79c.06,1.4.3,2.16.49,2.66.26.67.57,1.15,1.07,1.65s.98.81,1.65,1.07c.51.2,1.26.43,2.66.49,1.51.07,1.96.08,5.79.08s4.28-.02,5.79-.08c1.4-.06,2.16-.3,2.66-.49.67-.26,1.14-.57,1.65-1.07.5-.5.81-.98,1.07-1.65.2-.5.43-1.26.49-2.66.07-1.51.08-1.96.08-5.79s-.01-4.28-.08-5.79c-.06-1.4-.3-2.16-.49-2.66ZM20.64,28.42c-4.06,0-7.36-3.29-7.36-7.36s3.29-7.36,7.36-7.36h0c4.06,0,7.36,3.29,7.36,7.36s-3.29,7.36-7.36,7.36ZM28.28,15.13c-.95,0-1.72-.77-1.72-1.72s.77-1.72,1.72-1.72h0c.95,0,1.72.77,1.72,1.72s-.77,1.72-1.72,1.72Z",
    style: {
      fill: "#ff9be7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.64,16.29c-2.64,0-4.78,2.14-4.78,4.78s2.14,4.78,4.78,4.78,4.78-2.14,4.78-4.78-2.14-4.78-4.78-4.78Z",
    style: {
      fill: "#ff9be7",
      strokeWidth: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInsta);
export default __webpack_public_path__ + "static/media/activeInsta.3102b1928ba27dd851f96a7f3a6ef841.svg";
export { ForwardRef as ReactComponent };